import { RefObject, useEffect, useCallback } from "react"

export const useClickOutside = (
  ref: RefObject<Element>,
  callback: () => void
) => {
  const handleClick = useCallback(
    (e: MouseEvent) => {
      if (!ref.current?.contains(e.target as Node)) {
        callback()
      }
    },
    [callback, ref]
  )

  useEffect(() => {
    window.addEventListener("mouseup", handleClick)
    return () => {
      window.removeEventListener("mouseup", handleClick)
    }
  }, [handleClick])
}
